module.exports = __webpack_public_path__ + "img/sf_go_vn.7f2cfe6.webp";